export default "__VITE_ASSET__CjbtPdpM__"